import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gddlysjglocatehistory/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getByLocationDatetime = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gddlysjglocatehistory/getbylocationdatetime/' + params.registrationNum + '/' + params.startDatetime + '/' + params.endDatetime + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const downloadDailyTracksByCreateDatetime = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gddlysjglocatehistory/downloaddailytracksbycreatedatetime/' + params.selectDatetime + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const deleteByCreateDatetimeRange = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gddlysjglocatehistory/deletebycreatedatetimerange/' + params.start + '/' + params.end + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

